import Translations from "translations/types";

const FILES_PAGE_KEY = "files_page" as const;
export const FILES_AVAILABLE_TO_SHARE_KEY = "available_file_to_share" as const;

const FILES_PAGE_STEPS = {
  DOCUMENTATION_TAB: "documentation_tab",
  FILES_TAB: "files_tab",
  SEARCH_TAB: "search_tab",
  SELECT_FILES: "select_files",
  SHOW_MORE_INFO: "show_more_info",
} as const;

const FILES_PAGE_HIS_STEPS = {
  FILE_TABLE_MENU_ACTION: "file_table_action_menu",
} as const;

export const FILES_PAGE = {
  key: FILES_PAGE_KEY,
  steps: {
    [FILES_PAGE_STEPS.DOCUMENTATION_TAB]: {
      intro: (t: Translations) => t.tours.files.stepD.intro,
      key: FILES_PAGE_STEPS.DOCUMENTATION_TAB,
      step: 4,
      title: (t: Translations) => t.tours.files.stepD.title,
    },
    [FILES_PAGE_STEPS.FILES_TAB]: {
      intro: (t: Translations) => t.tours.files.stepA.intro,
      key: FILES_PAGE_STEPS.FILES_TAB,
      step: 1,
      title: (t: Translations) => t.tours.files.stepA.title,
    },
    [FILES_PAGE_STEPS.SEARCH_TAB]: {
      intro: (t: Translations) => t.tours.files.stepE.intro,
      key: FILES_PAGE_STEPS.SEARCH_TAB,
      step: 5,
      title: (t: Translations) => t.tours.files.stepE.title,
    },
    [FILES_PAGE_STEPS.SELECT_FILES]: {
      intro: (t: Translations) => t.tours.files.stepB.intro,
      key: FILES_PAGE_STEPS.SELECT_FILES,
      step: 2,
      title: (t: Translations) => t.tours.files.stepB.title,
    },
    [FILES_PAGE_STEPS.SHOW_MORE_INFO]: {
      intro: (t: Translations) => t.tours.files.stepC.intro,
      key: FILES_PAGE_STEPS.SHOW_MORE_INFO,
      step: 3,
      title: (t: Translations) => t.tours.files.stepC.title,
    },
  },
} as const;

export const FILES_AVAILABLE_TO_SHARE = {
  key: FILES_AVAILABLE_TO_SHARE_KEY,
  steps: {
    [FILES_PAGE_HIS_STEPS.FILE_TABLE_MENU_ACTION]: {
      intro: (t: Translations) => t.tours.availableFilesToShare.stepA.intro,
      key: FILES_PAGE_HIS_STEPS.FILE_TABLE_MENU_ACTION,
      step: 1,
      title: (t: Translations) => t.tours.availableFilesToShare.stepA.title,
    },
  },
} as const;
